module.exports = __webpack_public_path__ + "03_long_brown.e940ec8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_long_brown.png
// module id = WGtE
// module chunks = 0